
// /**
//  * Predicts future data using Linear Trend Analysis for followers and engagement.
//  * @param {Array} datasets - The historical datasets
//  * @param {Number} futureDays - The number of future days to predict dynamically
//  * @returns {Array} - New datasets including predicted future values
//  */
// export function predictFutureData(datasets, futureDays) {
//     return datasets.map((profile) => {
//         const historicalData = profile.data;
//         const totalDays = historicalData.length;

//         console.log("Incoming dataset : ", datasets);

//         if (totalDays < 2) {
//             console.warn(`⚠️ Not enough data for prediction: ${profile.label || "Unknown Profile"}`);
//             return profile;
//         }

//         // ✅ Get the last recorded date
//         const lastDate = new Date(historicalData[historicalData.length - 1].date);

//         // ✅ Detect Growth Trend for Followers/Subscribers
//         const lastN = Math.min(7, totalDays);
//         const recentData = historicalData.slice(-lastN);
//         const audienceValues = recentData.map((item) => item.followers || item.subscribers || 0);

//         const totalChange = audienceValues[audienceValues.length - 1] - audienceValues[0];
//         const dailyGrowthRate = totalChange / (audienceValues.length - 1) || 0; // Average daily change

//         console.log(`📈 Audience Growth Rate: ${dailyGrowthRate.toFixed(2)} per day`);

//         // ✅ Determine the Primary Metric Based on Platform
//         const isYouTube = profile.platform === "YouTube";
//         const primaryMetric = isYouTube ? "subscribers" : "followers";

//         // ✅ Introduce Minor Randomness in Growth Rate (±10% Variation)
//         function getRandomizedGrowthRate(baseRate) {
//             const varianceFactor = 0.9 + Math.random() * 0.2; // Random multiplier between 0.9 and 1.1
//             return baseRate * varianceFactor;
//         }

//         // ✅ Convert Historical Data Values to `null`, Retaining Only Dates, Except for Last Actual Data Point
//         const processedHistoricalData = historicalData.map((item, index) => ({
//             date: item.date,
//             [primaryMetric]: index === historicalData.length - 1 ? item[primaryMetric] : null, // ✅ Preserve last actual data point
//             posts: index === historicalData.length - 1 ? item.posts : null, // ✅ Preserve last actual post engagement
//             videos: index === historicalData.length - 1 ? item.videos : null, // ✅ Preserve last actual video engagement
//         }));

//         console.log("Processed Historical Data : ", processedHistoricalData);
//         // ✅ Detect Posting Frequency (Variable Intervals)
//         const postDates = historicalData
//             .filter((item) => item.posts && item.posts.length > 0)
//             .map((item) => new Date(item.date));

//         const postingIntervals = postDates.slice(1).map((date, index) =>
//             Math.ceil((date - postDates[index]) / (1000 * 60 * 60 * 24))
//         );

//         console.log("📅 Posting Intervals: ", postingIntervals);
//         const variablePostingIntervals = postingIntervals.length > 0 ? postingIntervals : [2, 3, 4];

//         console.log("Recent dataset : ", recentData);

//         // ✅ Detect Peak Engagement Trends
//         const engagementMetrics = [
//             "likes", "comments", "shares", "love", "wow", "haha", "sad", "angry", 
//             "likeCount", "commentCount", "viewCount"
//         ];

//         const engagementTrends = engagementMetrics.reduce((acc, metric) => {
//             const values = recentData.map((item) => {
//                 const postEngagement = item.posts?.reduce(
//                     (sum, post) => sum + (post.postMetrics?.[metric] || 0),
//                     0 
//                 ) || 0;

//                 const videoEngagement = item.videos?.reduce(
//                     (sum, video) => sum + (video.videoMetrics?.[metric] || 0),
//                     0
//                 ) || 0;

//                 return postEngagement + videoEngagement;
//             });

//             console.log("Values for", metric, ":", values);

//             if (values.length > 1) {
//                 const totalEngagement = values.reduce((acc, val) => acc + val, 0);
//                 const nonZeroValues = values.filter(val => val > 0); // Get only non-zero engagement values
//                 const validLength = nonZeroValues.length > 0 ? nonZeroValues.length : 1; // Avoid division by zero

//                 acc[metric] = Math.max(totalEngagement / validLength, 0); // Use count of non-zero values

//             } else {
//                 acc[metric] = 0;
//             }

//             return acc;
//         }, {});

//         console.log("📊 Engagement Trends:", engagementTrends);

//         // ✅ Generate Future Predictions with Dynamic Posting Days
//         let futureData = [];
//         let nextPostDay = 1;
//         for (let i = 1; i <= futureDays; i++) {
//             const futureDate = new Date(lastDate);
//             futureDate.setDate(lastDate.getDate() + i);

//             const adjustedGrowthRate = getRandomizedGrowthRate(dailyGrowthRate);
//             const predictedAudience = Math.round(audienceValues[audienceValues.length - 1] + adjustedGrowthRate * i);

//             const isPostingDay = i === nextPostDay;
//             if (isPostingDay) {
//                 nextPostDay += variablePostingIntervals[Math.floor(Math.random() * variablePostingIntervals.length)];
//             }

//             const predictedEngagement = isPostingDay
//                 ? Object.fromEntries(engagementMetrics.map((metric) => [metric, Math.max(engagementTrends[metric] * (0.8 + Math.random() * 0.4), 0)]))
//                 : Object.fromEntries(engagementMetrics.map((metric) => [metric, 0]));

//             futureData.push({
//                 date: futureDate.toISOString().split("T")[0],
//                 [primaryMetric]: predictedAudience,
//                 posts: isPostingDay && !isYouTube ? [{ postMetrics: predictedEngagement }] : [],
//                 videos: isPostingDay && isYouTube ? [{ videoMetrics: predictedEngagement }] : [],
//             });
//         }

//         console.log(`🔮 Generated Future Data for ${profile.label || "Unknown Profile"}`, futureData);

//         return {
//             ...profile,
//             data: [...processedHistoricalData, ...futureData], // 🔹 Apply Fix: Keep historical dates with `null` values
//             predicted: true,
//         };
//     });
// }

/**
 * Predicts future data using Linear Trend Analysis for followers and engagement.
 * @param {Array} datasets - The historical datasets
 * @param {Number} futureDays - The number of future days to predict dynamically
 * @returns {Array} - New datasets including predicted future values
 */
export function predictFutureData(datasets, futureDays) {
    return datasets.map((profile) => {
        const historicalData = profile.data;
        const totalDays = historicalData.length;

        // console.log("Incoming dataset : ", datasets);

        if (totalDays < 2) {
            console.warn(`⚠️ Not enough data for prediction: ${profile.label || "Unknown Profile"}`);
            return profile;
        }

        // ✅ Get the last recorded date
        const lastDate = new Date(historicalData[historicalData.length - 1].date);

        // ✅ Detect Growth Trend for Followers/Subscribers
        const lastN = Math.min(7, totalDays);
        const recentData = historicalData.slice(-lastN);
        const audienceValues = recentData.map((item) => item.followers || item.subscribers || 0);

        const totalChange = audienceValues[audienceValues.length - 1] - audienceValues[0];
        const dailyGrowthRate = totalChange / (audienceValues.length - 1) || 0; // Average daily change

        // console.log(`📈 Audience Growth Rate: ${dailyGrowthRate.toFixed(2)} per day`);

        // ✅ Determine the Primary Metric Based on Platform
        const isYouTube = profile.platform === "YouTube";
        const primaryMetric = isYouTube ? "subscribers" : "followers";

        // ✅ Introduce Minor Randomness in Growth Rate (±10% Variation)
        function getRandomizedGrowthRate(baseRate) {
            const varianceFactor = 0.9 + Math.random() * 0.2; // Random multiplier between 0.9 and 1.1
            return baseRate * varianceFactor;
        }

        // ✅ Convert Historical Data Values to `null`, Retaining Only Dates, Except for Last Two Actual Data Points
        const processedHistoricalData = historicalData.map((item, index) => ({
            date: item.date,
            [primaryMetric]: index >= historicalData.length - 2 ? item[primaryMetric] : null, // ✅ Preserve last two actual data points
            posts: index >= historicalData.length - 2 ? item.posts : [{
                postMetrics: Object.fromEntries(
                    ["likes", "like", "comments", "shares", "love", "wow", "haha", "sad", "angry", "likeCount", "commentCount", "viewCount"]
                        .map(metric => [metric, null])
                )
            }], // ✅ Preserve last two actual post engagement values
            videos: index >= historicalData.length - 2 ? item.videos : [{
                videoMetrics: Object.fromEntries(
                    ["likes", "like", "comments", "shares", "love", "wow", "haha", "sad", "angry", "likeCount", "commentCount", "viewCount"]
                        .map(metric => [metric, null])
                )
            }], // ✅ Preserve last two actual video engagement values
        }));

        // console.log("Processed Historical Data : ", processedHistoricalData);

        // ✅ Detect Posting Frequency (Variable Intervals)
        const postDates = historicalData
            .filter((item) => item.posts && item.posts.length > 0)
            .map((item) => new Date(item.date));

        const postingIntervals = postDates.slice(1).map((date, index) =>
            Math.ceil((date - postDates[index]) / (1000 * 60 * 60 * 24))
        );

        // console.log("📅 Posting Intervals: ", postingIntervals);
        const variablePostingIntervals = postingIntervals.length > 0 ? postingIntervals : [2, 3, 4];

        // console.log("Recent dataset : ", recentData);

        // ✅ Detect Peak Engagement Trends
        const engagementMetrics = [
            "likes", "like", "comments", "shares", "love", "wow", "haha", "sad", "angry",
            "likeCount", "commentCount", "viewCount"
        ];

        const engagementTrends = engagementMetrics.reduce((acc, metric) => {
            const values = recentData.map((item) => {
                const postEngagement = item.posts?.reduce(
                    (sum, post) => sum + (post.postMetrics?.[metric] || 0),
                    0
                ) || 0;

                const videoEngagement = item.videos?.reduce(
                    (sum, video) => sum + (video.videoMetrics?.[metric] || 0),
                    0
                ) || 0;

                return postEngagement + videoEngagement;
            });

            // console.log("Values for", metric, ":", values);

            if (values.length > 1) {
                const totalEngagement = values.reduce((acc, val) => acc + val, 0);
                const nonZeroValues = values.filter(val => val > 0); // Get only non-zero engagement values
                const validLength = nonZeroValues.length > 0 ? nonZeroValues.length : 1; // Avoid division by zero

                acc[metric] = Math.max(totalEngagement / validLength, 0); // Use count of non-zero values

            } else {
                acc[metric] = 0;
            }

            return acc;
        }, {});

        // console.log("📊 Engagement Trends:", engagementTrends);

        // ✅ Generate Future Predictions with Dynamic Posting Days
        let futureData = [];
        let nextPostDay = 1;
        for (let i = 1; i <= futureDays; i++) {
            const futureDate = new Date(lastDate);
            futureDate.setDate(lastDate.getDate() + i);

            const adjustedGrowthRate = getRandomizedGrowthRate(dailyGrowthRate);
            const predictedAudience = Math.round(audienceValues[audienceValues.length - 1] + adjustedGrowthRate * i);

            const isPostingDay = i === nextPostDay;
            if (isPostingDay) {
                nextPostDay += variablePostingIntervals[Math.floor(Math.random() * variablePostingIntervals.length)];
            }

            const predictedEngagement = isPostingDay
                ? Object.fromEntries(
                    engagementMetrics.map((metric) => [
                        metric,
                        Math.round(Math.max(engagementTrends[metric] * (0.8 + Math.random() * 0.4), 0))
                    ])
                )
                : Object.fromEntries(engagementMetrics.map((metric) => [metric, 0]));


            futureData.push({
                date: futureDate.toISOString().split("T")[0],
                [primaryMetric]: predictedAudience,
                posts: isPostingDay && !isYouTube ? [{ postMetrics: predictedEngagement }] : [],
                videos: isPostingDay && isYouTube ? [{ videoMetrics: predictedEngagement }] : [],
            });
        }

        // console.log(`🔮 Generated Future Data for ${profile.label || "Unknown Profile"}`, futureData);

        return {
            ...profile,
            data: [...processedHistoricalData, ...futureData], // 🔹 Keep last 2 actual data points
            predicted: true,
        };
    });
}


